import { render, staticRenderFns } from "./RdmAlert.vue?vue&type=template&id=19ce36d6&scoped=true&"
import script from "./RdmAlert.vue?vue&type=script&lang=ts&"
export * from "./RdmAlert.vue?vue&type=script&lang=ts&"
import style0 from "./RdmAlert.vue?vue&type=style&index=0&id=19ce36d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ce36d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCol,VIcon,VRow})
